import { RefreshCcwIcon } from "lucide-react";

import { Button } from "@/components/ui/ButtonNew";
import { ErrorScreenLayout } from "@/components/ui/errors/error-screen-layout";

import noInternetImage from "./assets/no-internet.svg";

// Pinned to one illustration: `ErrorScreenLayout` picks at random from whatever
// it's given, which meant the same failure could look different from one screen
// to the next. `no-internet-1.svg` is still in the repo if we want to swap.
const NO_INTERNET_IMAGES = [noInternetImage] as const;

export interface NoInternetConnectionProps {
  fullPage?: boolean;
  className?: string;
  /**
   * Retry handler. Defaults to a full reload. When this screen replaces the
   * whole route tree there is nothing left mounted to refetch on its own, so
   * without a way back the user is stranded here even after the backend
   * recovers — see `App.tsx`.
   */
  onRetry?: () => void;
}

const DEFAULT_MESSAGE = "Please check your internet connection and try again.";

export function NoInternetConnection({
  fullPage = false,
  className,
  onRetry,
}: NoInternetConnectionProps) {
  const handleRetry = onRetry ?? (() => window.location.reload());

  return (
    <ErrorScreenLayout
      fullPage={fullPage}
      className={className}
      message={DEFAULT_MESSAGE}
      images={NO_INTERNET_IMAGES}
      action={
        <Button
          variant="vibrant"
          onClick={handleRetry}
          className="h-auto min-h-0 gap-2 rounded-lg px-16 py-3 text-base font-normal shadow-none hover:shadow-none active:shadow-none"
        >
          Try again
          <RefreshCcwIcon
            className="size-4 shrink-0 stroke-[2.5]"
            aria-hidden
          />
        </Button>
      }
    />
  );
}
